// selectors.js
import { createSelector } from 'reselect';


const getDepart = (state) => state.DepartmentData.department;
export const selectDaparement = createSelector(
  [getDepart],
  (depart) => depart || { data: [] }
);


const getMainClothStk = (state) => state.ClothStockData.mainStk;
export const selectMainClothStk = createSelector(
  [getMainClothStk],
  (cloth) => cloth || { data: [] }
);


const getMultiQuotMemo = (state) => state.multipleQuotData.mqtMemo;
export const selectMultiQuotMemo = createSelector(
  [getMultiQuotMemo],
  (qt) => qt || { data: [] }
);

const getMultipleQuotdata = (state) => state.multipleQuotData.mqtData;
export const selectMultipleQuotData = createSelector(
  [getMultipleQuotdata],
  (qt) => qt || { data: [] }
);
export const selectMultipleQuotList = (state) =>
  state.multipleQuotData.mqtList || [];

const getEmpAttendanceReg = (state) => state.EmployeeData.atnd;
export const selectEmpAttendanceReg = createSelector(
  [getEmpAttendanceReg],
  (qt) => qt || { data: [] }
);